import React, { FC, useEffect } from "react";
import { IFormItem } from "../Types";
import { Form, TreeSelect } from "antd";

export const __FormTreeSelect: FC<IFormItem> = (props) => {
    useEffect(() => { console.log(props.treeDate) }, [])
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <TreeSelect
                treeDefaultExpandAll
                allowClear={props.allowClear}
                treeData={props.treeData}
                disabled={props.disable}
            />
        </Form.Item>
    )
}